import React, { useState } from 'react'
import Logo from '../assets/logo.webp';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Sidebar = ({product, setCollapsed, collapsed}) => {
    const navigate = useNavigate();
        // const [collapsed, setCollapsed] = useState(false);


  return (
    <>
    <section  className={`animate__animated animate__fadeInRight sidebar-left ${collapsed ? "" : "collapsed"}`}>

<div className='bg-white d-lg-flex text-lg-start text-center p-2 rounded-4'>
     <img src={Logo} className='header-logo' alt='Logo' />
     <p className='align-content-center ms-2 fw-semibold my-0'>DECTWIN<br />{product}</p>
     </div>

<div className='bg-white rounded-4 mt-3'>
    <p className='sidebar-text' onClick={() => {navigate('/admin/dashboard');  setCollapsed(false);}}>Dashboard</p>
    <p className='sidebar-text' onClick={() => {navigate('/admin/users'); setCollapsed(false);}}>Manage Users</p>

    {product != 'Hotel Management' &&
    <p className='sidebar-text' onClick={() => {navigate('/admin/plans');  setCollapsed(false);}}>Subscription Plan</p>}
    <p className='sidebar-text' onClick={async() => {
        
          const result = await Swal.fire({
                    title: `Log out?`,
                    text: `Want to Log out this Account?`,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: 'rgb(39, 172, 196)',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: `Yes, Confirm`,
                  });
        
                  if (result.isConfirmed) {
                            localStorage.removeItem('product'); window.location.href = '/admin-login'; 
                  }
        
}}>Logout</p>
</div>


 
    </section>

    </>
  )
}

export default Sidebar